import { render, staticRenderFns } from "./BookingFlightDataTable.vue?vue&type=template&id=0afddb3e&scoped=true&"
import script from "./BookingFlightDataTable.vue?vue&type=script&lang=js&"
export * from "./BookingFlightDataTable.vue?vue&type=script&lang=js&"
import style0 from "./BookingFlightDataTable.vue?vue&type=style&index=0&id=0afddb3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afddb3e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardTitle,VChip,VCol,VDataTable,VIcon,VRow,VSelect,VSpacer,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0afddb3e')) {
      api.createRecord('0afddb3e', component.options)
    } else {
      api.reload('0afddb3e', component.options)
    }
    module.hot.accept("./BookingFlightDataTable.vue?vue&type=template&id=0afddb3e&scoped=true&", function () {
      api.rerender('0afddb3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Booking/BookingFlightDataTable.vue"
export default component.exports